export default __webpack_public_path__ + "static/media/(74).850adb48.jpg";